import React, { useState, useEffect } from "react";
import {
    Tag,
    Space,
    Row,
    Col,
    Button,
    Checkbox,
    Input,
    Spin,
    DatePicker,
} from "antd";
import AppTable from "../../components/AppTable/AppTable";
import axiosGet from "../../helpers/AxiosRequest";
import { UrlConstants } from "../../helpers/UrlConstantsHelper";
import moment from "moment";
import "../Booking/Booking.scss";
import CorporateManual from "../../components/AppModal/CorporateManual";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DownloadOutlined } from '@ant-design/icons';
const { Search } = Input;

const BookingReport = () => {
    const [triplist, settriplist] = useState([]);
    const [isRowSelected, setIsRowSelected] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState([]);
    const [branchid, setbranchid]: any = useState(localStorage.getItem("cityid"));
    const [SearchText, setsearchText]: any = useState("");
    const [corporateManualModal, setcorporateManualModal] = useState(false);
    const [copytriplist, setcopytriplist] = useState(
        []
    );
    const [isLoading, setIsLoading] = useState(false);
    const [ButtonClicked, setIsButtonClicked] = useState("Today");
    const [fromdate, setfromdate]: any = useState(moment());
    const [todate, settodate]: any = useState(moment());
    const dateFormat = "DD/MM/YYYY";
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [Role, setRole]: any = useState(localStorage.getItem("roleid"));
    const [todayFlag, setTodayFlag] = useState(false);
    const [prevFlag, setPrevFlag] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [pagination, setPagination]: any = useState({
        current: 1,
        pageSize: 10,
    });

    const columns = [
        {
            title: "Book ID",
            dataIndex: "id",
            key: "Booking ID",
            ellipsis: true,
            fixed: "left",
            //sorter: (a: any, b: any) => a.id - b.id,
            width: "85px",

        },
        {
            title: "Name",
            dataIndex: "name",
            key: "Name",
            //ellipsis: true,
            fixed: "left",
            width: "200px",

        },
        {
            title: "Mobile",
            dataIndex: "mobileno",
            key: "Mobile",
            fixed: "left",
            width: "110px",
        },
        {
            title: "Cab ID",
            dataIndex: "cabid",
            key: "Cab ID",
            ellipsis: true,
            width: "95px",
        },
        {
            title: "Distance",
            dataIndex: "distance",
            key: "Distance",
            ellipsis: true,
            width: "110px",
        },
        {
            title: "Duration",
            dataIndex: "duration",
            key: "Duration",
            ellipsis: true,
            width: "110px",

        },
        {
            title: "Fare",
            dataIndex: "fare",
            key: "Fare",
            ellipsis: true,
            width: "85px",
        },
        {
            title: "Date",
            dataIndex: "assignedtime",
            key: "Date",
            ellipsis: true,
            width: "110px",
            render: (text: any, record: any) => {
                return {
                    children: <div>{moment(text).format("DD/MM/YYYY")}</div>,
                };
            },
        },
        {
            title: "Time",
            dataIndex: ["bookedtime", "assignedtime", "completedtime"],
            //dataIndex:"assignedtime",
            key: "Time",
            ellipsis: true,
            render: (text: any, record: any) => {
                return {

                    children: (
                        <div>
                            <Row>
                                B -{" "}
                                {record.bookedtime != undefined
                                    ? moment(record.bookedtime).format("hh:mm A")
                                    : ""}
                            </Row>
                            <Row>
                                A -{" "}
                                {record.assignedtime != undefined
                                    ? moment(record.assignedtime).format("hh:mm A")
                                    : ""}
                            </Row>
                            <Row>
                                C -{" "}
                                {record.completedtime != undefined
                                    ? moment(record.completedtime).format("hh:mm A")
                                    : ""}
                            </Row>
                        </div>
                    ),
                };
            },
            width: "110px",
        },
        {
            title: "From Location",
            dataIndex: "fromloc",
            key: "From Location",
        },
        {
            title: "To Location",
            dataIndex: "toloc",
            key: "To Location",
        },
        {
            title: "Vehicle",
            dataIndex: "vehicletype",
            key: "Vehicle",
            //ellipsis: true,
            width: "3%",
        },
        {
            title: "Fare Type",
            dataIndex: "faretype",
            key: "Fare Type",
        },
        {
            title: "Invoice No",
            dataIndex: "invoiceNo",
            key: "Invoice",
        },
        {
            title: "Customer Id",
            dataIndex: "customerId",
            key: "Cus_Id",
        },

        {
            title: "Goods",
            dataIndex: "goods",
            key: "Goods",
        },
        {
            title: "Vehicle Id",
            dataIndex: "vehicleid",
            key: "vehicle Id",//ellipsis: true,
            width: "110px",
        },
    ];
    const showcorpbillmodal = () => {
        setcorporateManualModal(true);
    };

    const hidecorpbillmodal = (isVisible: any) => {
        setcorporateManualModal(isVisible);
    };
    const onfromdatechange = (value: any) => {
        setfromdate(value);
        try {
            var fromdate = moment(value).format("YYYY/MM/DD");
            let todate = moment().format("YYYY/MM/DD");
            //DateSearch(fromdate, todate);
            setTodayFlag(false);
            setPrevFlag(false);
            //setfromdate(value);
        } catch (ex) {
            console.log(ex);
        }
    };
    const ontodatechange = (value: any) => {
        settodate(value);
        try {
            let startdate = moment(fromdate).format("YYYY/MM/DD");
            //DateSearch(startdate, todate);
            setTodayFlag(false);
            setPrevFlag(false);

            //settodate(moment(todate));
        } catch (ex) {
            console.log(ex);
        }
    };

    const adayclick = (event: any = null) => {
        setIsButtonClicked("Today");
        var first = moment();
        var firstday = first.format("DD");
        var firstmonth = first.format("MM");
        var firstyear = first.format("YYYY");
        let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
        setfromdate(moment(fromdate));
        //var new_date = moment().add('days', 1);
        var new_date = moment();
        var day = new_date.format("DD");
        var month = new_date.format("MM");
        var year = new_date.format("YYYY");
        let todate = year + "-" + month + "-" + day;
        settodate(moment(todate));
        setTodayFlag(true);
        setPrevFlag(false);
        onDateSearch(fromdate, todate, SearchText);
    };

    const twodayclick = () => {
        setIsButtonClicked("Yesday");
        var first = moment().add("days", -1);
        var firstday = first.format("DD");
        var firstmonth = first.format("MM");
        var firstyear = first.format("YYYY");
        let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
        setfromdate(moment(fromdate));
        var new_date = moment().add("days", -1);
        //var new_date = moment();
        var day = new_date.format("DD");
        var month = new_date.format("MM");
        var year = new_date.format("YYYY");
        let todate = year + "-" + month + "-" + day;
        settodate(moment(todate));
        setTodayFlag(false);
        setPrevFlag(true);
        onDateSearch(fromdate, todate, SearchText);
    };

    const monthclick = () => {
        setIsButtonClicked("Month");
        var first = moment();
        var firstmonth = first.format("MM");
        var firstyear = first.format("YYYY");
        let fromdate = firstyear + "-" + firstmonth + "-" + "01";
        setfromdate(moment(fromdate));
        //var new_date = moment().add('days', 1);
        var new_date = moment();
        var day = new_date.format("DD");
        var month = new_date.format("MM");
        var year = new_date.format("YYYY");
        let todate = year + "-" + month + "-" + day;
        settodate(moment(todate));
        setTodayFlag(true);
        setPrevFlag(false);
        onDateSearch(fromdate, todate, SearchText);
    };

    const weekclick = () => {
        setIsButtonClicked("Week");
        var first = moment().add("days", -moment().day());
        var firstday = first.format("DD");
        var firstmonth = first.format("MM");
        var firstyear = first.format("YYYY");
        let fromdate = firstyear + "-" + firstmonth + "-" + firstday;
        setfromdate(moment(fromdate));
        //var new_date = moment().add('days', 1);
        var new_date = moment();
        var day = new_date.format("DD");
        var month = new_date.format("MM");
        var year = new_date.format("YYYY");
        let todate = year + "-" + month + "-" + day;
        settodate(moment(todate));
        setTodayFlag(true);
        setPrevFlag(false);
        onDateSearch(fromdate, todate, SearchText);
    };
    const disabledDate = (current: any) => {
        // Can not select days before today and today
        return current && current > moment().endOf("day");
    };
    const disabledFromDate = (current: any) => {
        // Can not select days before today and today
        return current && current > moment(todate).endOf("day");
    };

    const onDateSearch = (
        fromdate: any,
        todate: any,
        SearchText: any
    ) => {
        DateSearch(
            moment(fromdate).format("YYYY/MM/DD"),
            moment(todate).add("days", 1).format("YYYY/MM/DD"),
            pagination,
            SearchText
        );
    };

    const DateSearch = (
        fromdate: any,
        todate: any,
        pagination: any,
        SearchText: any
    ) => {
        setIsLoading(true);
        const options: any = {
            params: {
                branchid: branchid,
                fromdate: fromdate,
                todate: todate,
                filtervalue: SearchText,
            },
        };
        axiosGet(UrlConstants.getBookingReport, options)
            .then((resp: any) => {
                resp.data.forEach((e: any) => {
                    e.key = e.id;
                    e.fare = isNaN(e.fare) ? e.fare.replace(/[^0-9]/g, "") : e.fare;
                });
                setIsLoading(false);
                settriplist(resp.data);
                setcopytriplist(resp.data);
                setTotalCount(resp.tablelength);
                setTotalAmount(resp.totalamount);
                setPagination({
                    ...pagination,
                    total: resp.tablelength,
                });
            })
            .catch(function (error: any) {
                setIsLoading(false);
                if (error.response) {
                    console.log(error.response.data, error.response.status);
                    settriplist([]);
                    setcopytriplist([]);
                }
            });
    };

    const onGridRowSelect = (rowInfo: any) => {
        setIsRowSelected(rowInfo.length > 0);
        setSelectedRowData(rowInfo);
    };
    useEffect(() => {
        adayclick();
    }, []);

    const onSearchchange = (e: any) => {
        setsearchText(e.target.value);
        globalSearch(e.target.value);
    };
    const globalSearch = (searchText: string) => {
        if (!triplist || triplist.length === 0) {
          setcopytriplist([]);
          setFilteredData([]);
          return;
        }
      
        const lowerSearch = searchText.toLowerCase();
      
        const filteredData = triplist.filter((value: any) => {
          return (
            (value.id && value.id.toString().toLowerCase().includes(lowerSearch)) ||
            (value.cabid && value.cabid.toString().toLowerCase().includes(lowerSearch)) ||
            (value.mobileno && value.mobileno.toString().toLowerCase().includes(lowerSearch)) ||
            (value.name && value.name.toString().toLowerCase().includes(lowerSearch)) ||
            (value.invoiceNo && value.invoiceNo.toString().toLowerCase().includes(lowerSearch)) ||
            (value.customerId && value.customerId.toString().toLowerCase().includes(lowerSearch))
          );
        });
      
        setcopytriplist(filteredData);
        setFilteredData(filteredData);
      };
      
    const getScrollX = () => {
        if (window.innerWidth < 768) return 600;
        if (window.innerWidth < 1024) return 1000;
        return 2850;
    };

    const exportToCSV = (data: any[], columns: any[], fileName = `Booking Report`) => {
        const exportData = data.map((row) => {
          const formattedRow: any = {};
      
          columns.forEach((col: any) => {
            const key = col.dataIndex;
      
            let columnTitle = '';
            if (typeof col.title === 'string') {
              columnTitle = col.title;
            } else if (typeof col.title === 'object' && col.title?.props?.children) {
              const children = col.title.props.children;
              const topLabel = Array.isArray(children) ? children[0] : children;
              columnTitle = typeof topLabel === 'string' ? topLabel : topLabel?.props?.children || '';
            }
      
            if (typeof key === 'string') {
              formattedRow[columnTitle.trim()] = row[key];
            }
          });
      
          return formattedRow;
        });
      
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
      
        const dataBlob = new Blob([excelBuffer], {
          type: "application/octet-stream",
        });
      
        saveAs(dataBlob, `${fileName}.xlsx`);
      };
      
    return (
        <div className="booking-child-routes">
            <div className="booking-child-routes-button-section">
                <Row style={{ paddingBottom: 7 }}>
                    <span
                        style={{
                            fontSize: "large",
                            fontWeight: "bold",
                            fontStyle: "Times New Roman",
                        }}
                    >
                        {" "}
                        From : {moment(fromdate).format("DD.MM.YYYY")} To :{" "}
                        {
                            todayFlag
                                ? moment().format("DD.MM.YYYY")
                                : /* (prevFlag ? moment().add('days', -1).format('DD.MM.YYYY') :  */ moment(
                                    todate
                                ).format("DD.MM.YYYY") /* ) */
                        }{" "}
                    </span>
                </Row>
                <Row

                    gutter={[16, 16]}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                    }}
                >
                    <Col>
                        <span style={{ fontSize: "medium" }}>From:</span>
                        <DatePicker
                            value={fromdate}
                            format={dateFormat}
                            disabledDate={disabledFromDate}
                            onChange={onfromdatechange}
                            style={{ marginLeft: 8 }}
                        />
                    </Col>

                    <Col>
                        <span style={{ fontSize: "medium", marginLeft: 8 }}>To:</span>
                        <DatePicker
                            value={
                                todayFlag
                                    ? moment()
                                    : prevFlag
                                        ? moment().add("days", -1)
                                        : todate
                            }
                            format={dateFormat}
                            disabledDate={disabledDate}
                            onChange={ontodatechange}
                            style={{ marginLeft: 8 }}
                        />
                    </Col>
                    <Col span={2} offset={1}>
            <Button icon={<DownloadOutlined />} type="primary" onClick={() => exportToCSV(triplist, columns)}>
            </Button>
          </Col>

                    <Col>
                        <Button
                            className="booking-btn-blockSearch"
                            onClick={() => onDateSearch(fromdate, todate, SearchText)}
                            disabled={moment(fromdate).isAfter(moment(todate))}
                        >
                            Search
                        </Button>
                    </Col>

                    <Col>
                        <Button
                            className="booking-btn-cancel"
                            disabled={!isRowSelected}
                            onClick={showcorpbillmodal}
                            style={{ marginLeft: 8 }}
                        >
                            Corporate Bill
                        </Button>
                    </Col>

                    <Col style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
                        <span style={{ fontSize: "large", fontWeight: "bold" }}>Trips:</span>
                        <span
                            style={{
                                fontSize: "large",
                                fontWeight: "bold",
                                paddingLeft: 10,
                                paddingRight: 20,
                            }}
                        >
                            {totalCount}
                        </span>
                    </Col>

                    <Col span={3} offset={1}>
                        <Input
                            placeholder="Search Text"
                            className="search"
                            onChange={onSearchchange}
                        />
                    </Col>
                </Row>
            </div>

            <div>
                <Spin tip="Loading..." spinning={isLoading}>
                    <AppTable
                        columns={columns}
                        data={copytriplist}
                        enablePagination={true}
                        defaultPageSize={100}
                        enableRadioButton={true}
                        onRadioButtonChange={onGridRowSelect}
                        selectionType="radio"
                        scroll={{ x: getScrollX(), y: 480 }}
                    />
                </Spin>
                <CorporateManual
                    title="Manual Bill"
                    visible={corporateManualModal}
                    hideModal={hidecorpbillmodal}
                    selectedRowData={selectedRowData}>
                </CorporateManual>
            </div>
        </div>
    );
};

export default BookingReport;
